<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='12'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <el-row>
            <el-col :span="2">
              <el-button type="primary" size="mini" round plain @click="Createtask()">创建信息</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" size="mini" round plain @click="Export()" icon="el-icon-download">采购明细导出</el-button>
            </el-col>
          </el-row>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <el-row>
              <el-col :span="8">
                <el-cascader v-model="company" :options="companyList" clearable filterable :props="{ value: 'id',label: 'name', checkStrictly: true }"  style="width: 100%;" placeholder="请选择厂区" @change="afreshData()" size="small"></el-cascader>
              </el-col>
              <el-col :span="7" style="margin-left: 10px;">
                <el-date-picker
                  v-model="addtimeBTTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="selectOperationTime"
                  size="small"
                >
                </el-date-picker>
              </el-col>
              <el-col :span="3">
                <el-input size="small" v-model="listQuery.price" clearable placeholder="金额" class="filter-item" style=" width:130px;">
                  <el-button slot="append" @click="selectNewDate()" style="width:50px;"><span style="margin-left: -6px;">搜索</span></el-button>
                </el-input>
              </el-col>
              <el-col v-if="current_user.id == 2 || current_user.id == 100" :span="2" style="margin-left:-15px;">
                <el-select v-model="listQuery.user_id" placeholder="用户" clearable @change="selectNewDate()" size="small">
                  <el-option
                    v-for="item in optionsUserList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" style="margin-left:10px;width: 190px;">
                <em style="font-size:14px;font-weight:bold;font-style:normal;color: #409eff;">总计：</em>
                <count-to :start-val="0" :end-val="amount" :duration="2600" :decimals="2" class="card-panel-num" style="color:#ff4949;font-weight:bold;font-size:14px;" />
                <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="operationManual"></i>
              </el-col>
              <!-- <el-col :span="1">
                <div style="padding-left:10px;">
                  <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="operationManual"></i>
                </div>
              </el-col> -->
            </el-row>
            <el-row>
              <el-col :span="3">
                <el-input size="small" v-model="listQuery.search" clearable placeholder="商品名称" class="filter-item" style="margin-bottom:8px;margin-top: 10px;">
                  <el-button slot="append" @click="selectNewDate()" style="width:50px;"><span style="margin-left: -6px;">搜索</span></el-button>
                </el-input>
              </el-col>
              <el-col :span="3">
                <el-select v-model="listQuery.pay_state" size="small" clearable placeholder="选择支付方式" style="margin-left: 8px;margin-bottom:10px;margin-top: 10px;" @change="selectNewDate()">
                  <el-option label="对公打款" value="1"></el-option>
                  <el-option label="现金线上支付" value="2"></el-option>
                  <el-option label="账期" value="3"></el-option>
                  <el-option label="现金线下支付" value="4"></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select v-model="listQuery.return_invoice" size="small" clearable placeholder="是否回票" style="margin-left: 8px;margin-bottom:10px;margin-top: 10px;" @change="selectNewDate()">
                  <el-option label="已回票" value="已回票"></el-option>
                  <el-option label="未回票" value="未回票"></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <!-- <el-select v-model="listQuery.pay_source" size="small" clearable placeholder="选择购买来源" style="margin-left: 10px;margin-bottom:10px;margin-top: 10px;" @change="selectNewDate()">
                  <el-option label="淘宝" value="1"></el-option>
                  <el-option label="本地" value="2"></el-option>
                  <el-option label="京东" value="3"></el-option>
                  <el-option label="西域" value="4"></el-option>
                  <el-option label="震坤行" value="5"></el-option>
                  <el-option label="微信" value="6"></el-option>
                  <el-option label="旺旺" value="7"></el-option>
                  <el-option label="拼多多" value="9"></el-option>
                  <el-option label="咸鱼" value="10"></el-option>
                  <el-option label="其他" value="8"></el-option>
                </el-select> -->
                <el-select v-model="listQuery.supplier_id" size="small" clearable filterable placeholder="供应商" style="margin-left: 8px;margin-bottom:10px;margin-top: 10px;" @change="selectNewDate()">
                  <el-option
                    v-for="item in SupplierOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-select v-model="listQuery.invoice" size="small" clearable placeholder="发票类型" style="margin-left: 10px;margin-bottom:8px;margin-top: 10px;" @change="selectNewDate()">
                  <el-option label="专票" value="1"></el-option>
                  <el-option label="普票" value="2"></el-option>
                  <el-option label="无" value="3"></el-option>
                </el-select>
              </el-col>
              <el-col :span="3">
                <el-input size="small" v-model="listQuery.requisitioner" clearable placeholder="申购人" class="filter-item" style="margin-left: 8px;margin-bottom:10px;margin-top: 10px;">
                  <el-button slot="append" @click="selectNewDate()" style="width:50px;"><span style="margin-left: -6px;">搜索</span></el-button>
                </el-input>
              </el-col>
              <el-col :span="3">
                <el-input size="small" v-model="listQuery.purchaser" clearable placeholder="购买人" class="filter-item" style="margin-left: 15px;margin-bottom:10px;margin-top: 10px;">
                  <el-button slot="append" @click="selectNewDate()" style="width:50px;"><span style="margin-left: -6px;">搜索</span></el-button>
                </el-input>
              </el-col>
              <el-col :span="3">
                <el-select v-model="listQuery.detaile_dstatus" size="small" clearable placeholder="明细状态" style="margin-left: 20px;margin-bottom:10px;margin-top: 10px;" @change="selectNewDate()">
                  <el-option label="未下单" value="1"></el-option>
                  <el-option label="已下单" value="2"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row style="position: static;">
              <el-col :span="24" class="task">
                <div ref="topScroll" class="top-scroll" @scroll="handleScrollTop">
                  <div class="top-scroll-content" :style="tableWidth"></div>
                </div>
                <el-table ref="singleTable" :data="list" border v-loading="qyloading" style="width: 100%" @header-click="dandian" height="680px">
                  <el-table-column label="日期" align="center" :fixed="isFixed[1]" width="100" :class-name="isFixed[1] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <span>{{ scope.row.addtime.substr(0,10) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="订单商品名称" align="center" :fixed="isFixed[20]"  :index="20" width="200" show-overflow-tooltip :class-name="isFixed[20] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <span>{{ scope.row.material_des }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="采买商品名称" align="center" :fixed="isFixed[2]"  :index="2" width="200" show-overflow-tooltip :class-name="isFixed[2] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <span>{{ scope.row.parets_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="单位" align="center" width="60" :fixed="isFixed[3]"  :index="3" :class-name="isFixed[3] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <span>{{ scope.row.units }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="数量" align="center" :fixed="isFixed[4]"  :index="4" :class-name="isFixed[4] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <span>{{ scope.row.number }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="采购单价" align="center" :fixed="isFixed[5]"  :index="5" :class-name="isFixed[5] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <span>{{ scope.row.price }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="采购总价" align="center" :fixed="isFixed[6]"  :index="6" :class-name="isFixed[6] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <span style="font-weight: bold;color: #ea4343;">{{ (scope.row.number*scope.row.price).toFixed(2) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="订单总价" align="center" :fixed="isFixed[7]"  :index="7" :class-name="isFixed[7] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <span>{{ scope.row.order_price }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="申购人" align="center" :fixed="isFixed[8]"  :index="8" :class-name="isFixed[8] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <span>{{ scope.row.requisitioner }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="购买人" align="center" :fixed="isFixed[19]"  :index="19" :class-name="isFixed[19] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <span>{{ scope.row.purchaser }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="明细状态" align="center" width="120" :fixed="isFixed[9]"  :index="9" :class-name="isFixed[9] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.detaile_dstatus" placeholder="请选择" @change="changedstatus(scope.row, 'detaile_dstatus')" :disabled="scope.row.business_orders_goods_id ? true : false" size="small">
                        <el-option label="未下单" value="1"></el-option>
                        <el-option label="已下单" value="2"></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column label="厂区" align="center" width="150" show-overflow-tooltip :fixed="isFixed[10]"  :index="10" :class-name="isFixed[10] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <!-- <el-popover trigger="hover" placement="top">
                        <p>{{ scope.row.companyName }}</p>
                        <div slot="reference" class="name-wrapper">
                          <span>{{ scope.row.plantName }}</span>
                        </div>
                      </el-popover> -->
                      <span>{{ scope.row.plantName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="是否回票" width="110" :fixed="isFixed[11]"  :index="11" :class-name="isFixed[11] ? 'my-custom-class' : ''">
                    <template slot-scope="{row}">
                      <!-- <el-select v-model="row.return_invoice" size="mini" placeholder="请选择" @change="changeinvoice(row)">
                        <el-option label="已回票" value="已回票"></el-option>
                        <el-option label="未回票" value="未回票"></el-option>
                      </el-select> -->
                      <span v-if="row.invoice === '3'">无票</span>
                      <el-switch
                        v-else
                        style="display: block"
                        v-model="row.return_invoice"
                        active-value="已回票"
                        inactive-value="未回票"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        @change="changeinvoice(row)"
                        active-text="是"
                        inactive-text="否"
                        disabled>
                      </el-switch>
                      <!-- <span v-if="row.return_invoice === '已回票'">已回票</span>
                      <span v-if="row.return_invoice === '未回票'" style="color: rgb(255, 73, 73);">未回票</span> -->
                    </template>
                  </el-table-column>
                  <el-table-column type="selection" width="50" :fixed="isFixed[12]"  :index="12" :class-name="isFixed[12] ? 'my-custom-class' : ''"></el-table-column>
                  <el-table-column label="是否采购" align="center">
                    <template slot-scope="scope">
                      <span>{{ scope.row.is_purchase }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="支付方式" width="120" :fixed="isFixed[13]" :index="13" :class-name="isFixed[13] ? 'my-custom-class' : ''">
                    <template slot-scope="{row}">
                      <!-- <el-select v-model="row.pay_state" size="mini" placeholder="请选择" @change="changeState(row)">
                        <el-option label="对公打款" value="1"></el-option>
                        <el-option label="现金线上支付" value="2"></el-option>
                      </el-select> -->
                      <span v-if="row.buy_detail_purchase[0].pay_state === '1'">对公打款</span>
                      <span v-if="row.buy_detail_purchase[0].pay_state === '2'">现金线上支付</span>
                      <span v-if="row.buy_detail_purchase[0].pay_state === '3'">账期</span>
                      <span v-if="row.buy_detail_purchase[0].pay_state === '4'">现金线下支付</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="购买来源" width="110" :fixed="isFixed[14]" :index="14" :class-name="isFixed[14] ? 'my-custom-class' : ''">
                    <template slot-scope="{row}">
                      <!-- <el-select v-model="row.pay_source" size="mini" placeholder="请选择" @change="changeState(row)">
                        <el-option label="淘宝" value="1"></el-option>
                        <el-option label="本地" value="2"></el-option>
                        <el-option label="京东" value="3"></el-option>
                        <el-option label="西域" value="4"></el-option>
                        <el-option label="震坤行" value="5"></el-option>
                        <el-option label="其他" value="6"></el-option>
                      </el-select> -->
                      <span v-if="row.buy_detail_purchase[0].pay_source === '1'">淘宝</span>
                      <span v-if="row.buy_detail_purchase[0].pay_source === '2'">本地</span>
                      <span v-if="row.buy_detail_purchase[0].pay_source === '3'">京东</span>
                      <span v-if="row.buy_detail_purchase[0].pay_source === '4'">西域</span>
                      <span v-if="row.buy_detail_purchase[0].pay_source === '5'">震坤行</span>
                      <span v-if="row.buy_detail_purchase[0].pay_source === '6'">微信</span>
                      <span v-if="row.buy_detail_purchase[0].pay_source === '7'">旺旺</span>
                      <span v-if="row.buy_detail_purchase[0].pay_source === '9'">拼多多</span>
                      <span v-if="row.buy_detail_purchase[0].pay_source === '10'">咸鱼</span>
                      <span v-if="row.buy_detail_purchase[0].pay_source === '8'">其他</span>
                      <span v-if="row.buy_detail_purchase[0].pay_source === '11'">线下实体</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="发票" width="100" :fixed="isFixed[15]" :index="15" :class-name="isFixed[15] ? 'my-custom-class' : ''">
                    <template slot-scope="{row}">
                      <!-- <el-select v-model="row.invoice" size="mini" placeholder="请选择" @change="changeState(row)">
                        <el-option label="专票" value="1"></el-option>
                        <el-option label="普票" value="2"></el-option>
                        <el-option label="无" value="3"></el-option>
                      </el-select> -->
                      <span v-if="row.buy_detail_purchase[0].invoice === '1'">专票</span>
                      <span v-if="row.buy_detail_purchase[0].invoice === '2'">普票</span>
                      <span v-if="row.buy_detail_purchase[0].invoice === '3'">无</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="来源信息" align="center" width="150" :fixed="isFixed[16]" :index="16" :class-name="isFixed[16] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <el-popover placement="top" trigger="hover">
                        <template>
                          <div style="width:500px" v-if="scope.row.buy_detail_purchase[0].pay_address" class="set-popper">{{ scope.row.buy_detail_purchase[0].pay_address }}
                            <el-link v-if="getUrl(scope.row.buy_detail_purchase[0].pay_address)" :href="getUrl(scope.row.buy_detail_purchase[0].pay_address)" type="primary" target="_blank">前往</el-link>
                          </div>
                        </template>
                        <div slot="reference" class="set-content">
                          {{ scope.row.buy_detail_purchase[0].pay_address }}
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="物流单号" align="center" width="150px" :fixed="isFixed[17]" :index="17" :class-name="isFixed[17] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                        <span @click="checkLogistics(scope.row)" style="cursor: pointer; color: cornflowerblue;">{{ scope.row.buy_detail_purchase[0].tracking_number }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="备注" align="center" width="200" :fixed="isFixed[18]" :index="18" :class-name="isFixed[18] ? 'my-custom-class' : ''">
                    <template slot-scope="scope">
                      <el-popover placement="top" trigger="hover">
                        <template>
                          <div style="width:800px" v-if="scope.row.buy_detail_purchase[0].remark" class="set-popper" v-html="scope.row.buy_detail_purchase[0].remark.replace(/\n/g, '<br>')"></div>
                        </template>
                        <div slot="reference" class="set-content">
                          {{ scope.row.buy_detail_purchase[0].remark }}
                        </div>
                      </el-popover>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center"  fixed="right">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                      >
                        <p>确定删除该产品吗？</p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="expenseDelete(scopes.row,scopes.$index,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="click">
                        <ul>
                          <li v-for="(item,index) in scopes.row.buy_detail_purchase[0].voucher" :key="index" style="padding: 8px 15px 8px;">
                            <span>{{ item.name }}</span>
                            <el-button type="primary" plain size="mini" style="float: right;" @click="dowloadFile(item.response)">预览</el-button>
                          </li>
                          <li v-for="(item,index) in scopes.row.receipt" :key="index" style="padding: 8px 15px 8px;">
                            <span>{{ item.name }}</span>
                            <el-button type="primary" plain size="mini" style="float: right;" @click="dowloadFile(item.response)">发票</el-button>
                          </li>
                        </ul>
                        <el-button v-show="scopes.row.buy_detail_purchase[0].voucher.length > 0 || scopes.row.receipt" slot="reference" size="mini" type="text">凭证文件</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
    <el-dialog :visible.sync="dialogFormVisible" width="75%" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <div class="borderStyleS">
          订单列表
        </div>
        <div class="border-box">
          <el-alert
            v-if="form.is_income == '1'"
            title="该订单为总账号填入订单，请谨慎操作，该账单价格计入总账号，不计入个人账户"
            type="warning"
            effect="dark">
          </el-alert>
          <el-row style="margin-top: 20px">
            <el-col :span="22">
              <el-form-item label="订单详情">
                <el-cascader ref="cascader" v-model="form.businessOrdersList" :options="businessOrdersList" clearable filterable :filter-method="customFilterMethod" :props="{ value: 'id', label: 'name' }" style="width: 100%;" @change="handleChange"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="订单号/编码">
                <el-input v-model="form.ordnumber_code"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="厂区" prop="companyList">
                <el-cascader v-model="form.companyList" :options="companyList" clearable filterable :props="{ value: 'id',label: 'name' }" style="width: 100%;"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="采购描述" prop="parets_name">
                <el-input v-model="form.parets_name" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="产品分类">
                <el-cascader v-model="form.cateList" :options="cateList" clearable filterable :props="{ value: 'id',label: 'title' }" style="width: 100%;"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="是否采购" prop="is_purchase">
                <el-radio-group v-model="form.is_purchase" size="mini">
                  <el-radio-button label="是" value="是"></el-radio-button>
                  <el-radio-button label="否" value="否"></el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="单位" prop="units">
                <el-input v-model="form.units"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="申购人">
                <el-input v-model="form.requisitioner" placeholder="申购人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="购买人">
                <el-input v-model="form.purchaser" placeholder="购买人"></el-input>
              </el-form-item>
            </el-col>
            <el-col v-if="current_user.id == 2 || current_user.id == 100" :span="6">
              <el-form-item label="分配业务员" prop="user_id">
                <el-select v-model="form.user_id" placeholder="请选择业务员" clearable style="width: 80%;">
                  <el-option
                    v-for="item in optionsUserList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="数量" prop="number">
                <el-input-number v-model="form.number" size="small" :precision="2" :min="0" :step="0.1" ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="采购单价" prop="price">
                <!-- <el-input v-model="form.price"></el-input> -->
                <el-input-number v-model="form.price" size="small" :precision="3" :min="0" :step="1" ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="采购总价">
                <div class="borderStyle">
                  <span style="font-weight: bold;color: #ea4343;">{{ (form.number*form.price).toFixed(3) }}</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单总价">
                <div class="borderStyle">
                  <span style="font-weight: bold;color: #ea4343;">{{ Number(form.order_price).toFixed(3) }}</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="borderStyleS" @click="addTab(editableTabsValue)" style="cursor: pointer;">
          采购信息<i class="el-icon-circle-plus-outline"></i>
        </div>
        <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab">
          <el-tab-pane
            v-for="(itemss, indexss) in form.buy_detail_purchase"
            :key="itemss.name"
            :label="itemss.title"
            :name="itemss.name"
            style="border: 1px solid #DCDFE6;border-bottom-left-radius: 4px;border-bottom-right-radius: 4px;border-top-right-radius: 4px;"
          >
            <div class="border-boxs">
              <el-row style="margin-top: 20px">
                <el-col :span="7">
                  <el-form-item label="支付方式" :prop="`buy_detail_purchase.${indexss}.buy_detail_purchase.pay_state`" :rules="rules.buy_detail_purchase.pay_state">
                    <el-select v-model="itemss.buy_detail_purchase.pay_state" placeholder="请选择支付方式" @change="handleChangePayState(itemss, indexss)">
                      <el-option label="对公打款" value="1"></el-option>
                      <el-option label="现金线上支付" value="2"></el-option>
                      <el-option label="账期" value="3"></el-option>
                      <el-option label="现金线下支付" value="4"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="7" v-if="form.pay_state === '2'">
                  <el-form-item label="">
                    <el-checkbox v-model="form.buy_type">纳入账单支付</el-checkbox>
                  </el-form-item>
                </el-col> -->
                <el-col :span="7">
                  <el-form-item label="购买来源" :prop="`buy_detail_purchase.${indexss}.buy_detail_purchase.pay_source`" :rules="rules.buy_detail_purchase.pay_source">
                    <el-select v-model="itemss.buy_detail_purchase.pay_source" placeholder="请选择购买来源" width="100%">
                      <el-option label="淘宝" value="1"></el-option>
                      <el-option label="本地" value="2"></el-option>
                      <el-option label="京东" value="3"></el-option>
                      <el-option label="西域" value="4"></el-option>
                      <el-option label="震坤行" value="5"></el-option>
                      <el-option label="微信" value="6"></el-option>
                      <el-option label="旺旺" value="7"></el-option>
                      <el-option label="拼多多" value="9"></el-option>
                      <el-option label="咸鱼" value="10"></el-option>
                      <el-option label="其他" value="8"></el-option>
                      <el-option label="线下实体" value="11"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item label="发票类型" :prop="`buy_detail_purchase.${indexss}.buy_detail_purchase.invoice`" :rules="rules.buy_detail_purchase.invoice">
                    <el-select v-model="itemss.buy_detail_purchase.invoice" placeholder="请选择发票类型">
                      <el-option label="专票" value="1"></el-option>
                      <el-option label="普票" value="2"></el-option>
                      <el-option label="无" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="itemss.buy_detail_purchase.pay_state == '2'">
                <el-col :span="11">
                  <el-form-item label="店铺信息" :prop="`buy_detail_purchase.${indexss}.buy_detail_purchase.shop`" :rules="rules.buy_detail_purchase.shop">
                    <el-input v-model="itemss.buy_detail_purchase.shop" placeholder="填写：店铺信息"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="来源信息" :prop="`buy_detail_purchase.${indexss}.buy_detail_purchase.pay_address`" :rules="rules.buy_detail_purchase.pay_address">
                    <el-input v-model="itemss.buy_detail_purchase.pay_address" placeholder="填写：产品链接"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="itemss.buy_detail_purchase.pay_state == '3'">
                <el-col :span="22">
                  <el-form-item label="对公开户信息">
                    <el-input v-model="itemss.buy_detail_purchase.open_info" type="textarea" :rows="4"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="itemss.buy_detail_purchase.pay_state == '1' || itemss.buy_detail_purchase.pay_state == '4'">
                <el-col :span="7">
                  <el-form-item label="供应商信息">
                    <el-select
                      v-model="itemss.buy_detail_purchase.supplier_id"
                      filterable
                      remote
                      clearable
                      reserve-keyword
                      placeholder="请输入供应商信息"
                      :remote-method="remoteMethod"
                      @change="changesupplier(indexss)"
                      :loading="loading">
                      <el-option
                        v-for="items in options"
                        :key="items.id"
                        :label="items.company_name"
                        :value="items.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item label="纳税人识别号">
                    <el-input v-model="itemss.SupplierList.taxnum"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7" v-if="itemss.buy_detail_purchase.pay_state !== '4'">
                  <el-form-item label="打款信息">
                    <el-input v-model="itemss.SupplierList.bank_account"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7" v-if="itemss.buy_detail_purchase.pay_state == '4'">
                  <el-form-item label="公司地址">
                    <el-input v-model="itemss.SupplierList.company_address"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="物流方式">
                    <el-radio-group v-model="itemss.buy_detail_purchase.logistics_type" size="mini">
                      <el-radio-button label="快递" value="快递"></el-radio-button>
                      <el-radio-button label="自提" value="自提"></el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="5" v-if="itemss.buy_detail_purchase.logistics_type == '快递'">
                  <el-form-item label="快递选择">
                    <el-select v-model="itemss.buy_detail_purchase.logistics" placeholder="选择快递">
                      <el-option v-for="(items,index) in gridData" :key="index" :label="items.label" :value="items"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6" v-if="itemss.buy_detail_purchase.logistics_type == '快递'">
                  <el-form-item label="物流号码">
                    <el-input v-model="itemss.buy_detail_purchase.tracking_number" placeholder="物流号码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col v-if="itemss.buy_detail_purchase.logistics.value === 'SF'" :span="6">
                  <el-form-item label="手机号码">
                    <el-input v-model="itemss.buy_detail_purchase.tel" placeholder="收/寄件人手机号"></el-input>
                  </el-form-item>
                </el-col>
                <el-col v-if="itemss.buy_detail_purchase.logistics_type == '自提'" :span="6">
                  <el-form-item label="送货人">
                    <el-input v-model="itemss.buy_detail_purchase.deliveryMan" placeholder="送货人"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22">
                  <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" :rows="4" v-model="itemss.buy_detail_purchase.remark"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="上传类型">
                    <el-radio-group v-model="itemss.buy_detail_purchase.upload_type" size="mini">
                      <el-radio-button label="回执单" value="回执单"></el-radio-button>
                      <el-radio-button label="收据" value="收据"></el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="上传文件" prop="img">
                    <el-upload
                      ref="upload"
                      class="upload-demo"
                      :action="upload_url"
                      :on-success="handlesuccess.bind(null, {'index':indexss})"
                      :on-remove="removeUpload.bind(null, {'index':indexss})"
                      :before-upload="beforeAvatarUpload"
                      accept=".xls,.xlsx,.docx,.doc,.jpg,.png,.pdf,.zip,.rar"
                      :file-list="itemss.buy_detail_purchase.voucher"
                      :headers="requestHeaders"
                      :auto-upload="true"
                      :multiple="true"
                    >
                      <el-button v-if="itemss.buy_detail_purchase.upload_type == '回执单'" slot="trigger" size="small" type="primary">上传回执单</el-button>
                      <el-button v-if="itemss.buy_detail_purchase.upload_type == '收据'" slot="trigger" size="small" type="primary">上传收据</el-button>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="采购时间" required>
                    <el-form-item prop="addtime">
                      <el-date-picker type="datetime" placeholder="选择日期时间" v-model="itemss.buy_detail_purchase.addtime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" :clearable="false"></el-date-picker>
                    </el-form-item>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="borderStyleS" style="margin-top: 10px">
          发票管理
        </div>
        <div class="border-box">
          <el-row style="margin-top: 20px">
            <el-col :span="7">
              <el-form-item label="是否回票" prop="return_invoice">
                <el-radio-group v-model="form.return_invoice" size="mini" disabled>
                  <el-radio-button label="已回票" value="已回票"></el-radio-button>
                  <el-radio-button label="未回票" value="未回票"></el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="上传发票" prop="img">
                <el-upload
                  ref="upload"
                  class="upload-demo"
                  :action="upload_url"
                  :on-success="handlesuccess_invoice"
                  :on-remove="removeUpload_invoice"
                  :before-upload="beforeAvatarUpload"
                  accept=".xls,.xlsx,.docx,.doc,.jpg,.png,.pdf,.zip,.rar"
                  :file-list="myfileList_invoice"
                  :headers="requestHeaders"
                  :auto-upload="true"
                  :multiple="true"
                >
                  <el-button slot="trigger" size="small" type="primary">上传发票</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog>
    <el-image
      style="width: 0px; height: 0px"
      src="https://serv.nmzp.com/uploads/1/image/20240411/061e6fd50a7666ee73101bbd50414bda.jpg"
      :lazy="true"
      ref="preview"
      :preview-src-list="srcList"
    >
    </el-image>
    <el-dialog title="物流信息" :visible.sync="isShow" @close="close" style="height:700px;">
      <el-timeline :reverse="reverse">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          color= '#fe722c'
          :timestamp="activity.time">
          {{activity.status}}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import vuelist from '@/utils/vue_list'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/expense'
import busOrders from '@/api/businessOrders'
import workdiary from '@/api/workdiary'
import CountTo from 'vue-count-to'
import apiConfig from '../../../config/api.config.js'
import { getToken } from '@/utils/auth'

export default {
  name: 'ExpenseAccount',
  mixins: [vuelist],
  components: { Top, LeftNav, Bottom, Pagination, CountTo },
  data () {
    return {
      api,
      srcList: ['https://serv.nmzp.com/uploads/1/image/20240411/061e6fd50a7666ee73101bbd50414bda.jpg', 'https://serv.nmzp.com/uploads/1/image/20240411/58a0fc4a46e2f1bb9b7d3dfe1499a333.jpg'],
      businessOrdersList: [],
      companyList: [],
      company: [],
      listQuery: {
        limit: 10,
        page: 1,
        order: 'addtime'
        // detaile_dstatus: '1'
      },
      SupplierOptions: [],
      isFixed: { 0: false, 1: true, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 17: false, 18: false, 19: false, 20: false },
      qyloading: false,
      dialogFormVisible: false,
      locktype: false,
      cateList: [],
      loading: false,
      options: [],
      form: {
        businessOrdersList: [],
        companyList: [],
        buy_detail_purchase: [],
        parets_name: '',
        ordnumber_code: '',
        units: '',
        number: '',
        price: '',
        order_price: '',
        pay_state: '',
        pay_source: '',
        shop: '',
        pay_address: '',
        open_info: '',
        invoice: '',
        is_purchase: '否',
        return_invoice: '未回票',
        addtime: new Date(),
        remark: '',
        requisitioner: '',
        cateList: [],
        logistics: [],
        tracking_number: '',
        tel: '',
        is_income: '0'
      },
      amount: 0.00,
      rules: {
        companyList: [{ required: true, message: '请选择厂区', trigger: 'blur' }],
        parets_name: [{ required: true, message: '请输入采购描述', trigger: 'blur' }],
        units: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        user_id: [{ required: true, message: '请选择分配业务员', trigger: 'blur' }],
        number: [
          { required: true, message: '请输入数量', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value === 0 || value === '0') {
                callback(new Error('请输入非零数值'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        price: [
          { required: true, message: '请输入采购价', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value < 0) {
                callback(new Error('请输入非零数值'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        buy_detail_purchase: {
          pay_state: [{ required: true, message: '请选择支付方式', trigger: 'blur' }],
          pay_source: [{ required: true, message: '请选择购买来源', trigger: 'blur' }],
          invoice: [{ required: true, message: '请选择发票类型', trigger: 'blur' }],
          addtime: [{ required: true, message: '请选择采购时间', trigger: 'blur' }],
          shop: [{ required: true, message: '请输入店铺信息', trigger: 'blur' }],
          pay_address: [{ required: true, message: '请输入产品来源信息', trigger: 'blur' }]
        }
      },
      addtimeBTTime: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      dialogVisible: false,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_workdiary',
      requestHeaders: {
        'X-Token': getToken()
      },
      myfileList_invoice: [],
      primary_key: 'id',
      optionsUserList: [],
      gridData: [
        {
          label: '德邦快递',
          value: 'DBL'
        },
        {
          label: '顺丰速运',
          value: 'SF'
        },
        {
          label: '京东',
          value: 'JD'
        },
        {
          label: '百世快递',
          value: 'HTKY'
        },
        {
          label: '中通快递',
          value: 'ZTO'
        },
        {
          label: '申通快递',
          value: 'STO'
        },
        {
          label: '圆通速递',
          value: 'YTO'
        },
        {
          label: '韵达速递',
          value: 'YD'
        },
        {
          label: '邮政快递包裹',
          value: 'YZPY'
        },
        {
          label: 'EMS',
          value: 'EMS'
        },
        {
          label: '天天快递',
          value: 'HHTT'
        },
        {
          label: '优速快递',
          value: 'UC'
        },
        {
          label: '宅急送',
          value: 'ZJS'
        },
        {
          label: '顺心捷达',
          value: 'SXJD'
        },
        {
          label: '安能',
          value: 'ANE'
        },
        {
          label: '其他',
          value: 'qts'
        }
      ],
      reverse: true,
      activities: [],
      isShow: false,
      tableWidth: {
        width: 0
      },
      editableTabsValue: '1',
      tabIndex: 1,
      buy_detail_purchase_arr: []
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.LoadData()
    this.getCompanyList()
    this.getcateGoods()
    this.getUserList()
    this.getAllSupplierList()
  },
  methods: {
    changesupplier (indexss) {
      if (this.form.buy_detail_purchase[indexss].buy_detail_purchase.supplier_id) {
        this.options.map(res => {
          if (this.form.buy_detail_purchase[indexss].buy_detail_purchase.supplier_id === res.id) {
            this.form.buy_detail_purchase[indexss].SupplierList = res
            this.form.buy_detail_purchase[indexss].buy_detail_purchase.pay_address = res['company_url']
          }
        })
      } else {
        this.form.buy_detail_purchase[indexss].SupplierList = []
        this.options = []
      }
    },
    getCompanyList () {
      api.getCompanyList().then(response => {
        this.companyList = response.message
      })
    },
    Createtask () {
      this.getBusinessOrdersList('1')
      this.dialogFormVisible = true
      this.locktype = false
      this.editableTabsValue = '1'
      this.form = {
        businessOrdersList: [],
        companyList: [],
        buy_detail_purchase: [
          {
            title: '采购信息1',
            name: '1',
            SupplierList: [],
            buy_detail_purchase: {
              buy_detail_id: null,
              pay_state: '',
              pay_source: '',
              invoice: '',
              shop: '',
              pay_address: '',
              open_info: '',
              supplier_id: null,
              logistics_type: '快递',
              logistics: [],
              tracking_number: '',
              tel: '',
              deliveryMan: '',
              remark: '',
              upload_type: '回执单',
              voucher: [],
              addtime: new Date(),
              order: '1'
            }
          }
        ],
        parets_name: '',
        ordnumber_code: '',
        units: '',
        number: '',
        price: '',
        order_price: '',
        pay_state: '',
        pay_source: '',
        shop: '',
        pay_address: '',
        open_info: '',
        invoice: '',
        is_purchase: '否',
        return_invoice: '未回票',
        addtime: new Date(),
        remark: '',
        requisitioner: '',
        purchaser: '',
        cateList: [],
        logistics: [],
        tracking_number: '',
        tel: '',
        is_income: '0'
      }
      this.myfileList_invoice = []
    },
    submitForm () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.locktype) {
            return false
          }
          this.locktype = true
          this.form.receipt = this.myfileList_invoice
          if (this.current_user.id === 2) {
            this.form.is_income = '1'
          }
          api.submitForm(this.form).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            this.LoadData()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        }
      })
    },
    handleEdit (index, row) {
      this.getBusinessOrdersList(row.business_orders_goods_id)
      this.dialogFormVisible = true
      this.form = Object.assign({}, row)
      this.form.companyList = [row.group_list_id, row.company_id, row.plant_id]
      this.form.cateList = [row.category_grand_id, row.category_parent_id]
      this.form.businessOrdersList = [row.business_orders_goods_id]
      if (row.receipt) {
        this.myfileList_invoice = row.receipt
      } else {
        this.myfileList_invoice = []
      }
      this.buy_detail_purchase_arr = []
      if (this.form.buy_detail_purchase.length > 0) {
        for (var i = 0; i < this.form.buy_detail_purchase.length; i++) {
          if (this.form.buy_detail_purchase[i].voucher) {
            this.form.buy_detail_purchase[i].voucher = this.form.buy_detail_purchase[i].voucher
          } else {
            this.form.buy_detail_purchase[i].voucher = []
          }
          this.buy_detail_purchase_arr.push({
            title: '采购信息' + this.form.buy_detail_purchase[i].order,
            name: this.form.buy_detail_purchase[i].order,
            SupplierList: [],
            buy_detail_purchase: this.form.buy_detail_purchase[i]
          })
          this.editableTabsValue = this.form.buy_detail_purchase[i].order
        }
        this.form.buy_detail_purchase = this.buy_detail_purchase_arr
        for (var j = 0; j < this.form.buy_detail_purchase.length; j++) {
          if (this.form.buy_detail_purchase[j].buy_detail_purchase.supplier_id) {
            this.geteditSupplierList(this.form.buy_detail_purchase[j].buy_detail_purchase.supplier_id, j)
          } else {
            this.options = []
            this.form.buy_detail_purchase[j].SupplierList = []
          }
        }
      }
    },
    expenseDelete (row, index, scopes) {
      api.expenseDelete({ id: row.id }).then(response => {
        scopes._self.$refs[`popover-${scopes.$index}`].doClose()
        this.LoadData()
      })
    },
    selectNewDate () {
      this.listQuery.page = 1
      this.LoadData()
    },
    afreshData () {
      this.listQuery.page = 1
      if (this.company.length === 1) {
        this.listQuery.group_list_id = this.company[0]
        this.listQuery.company_id = null
        this.listQuery.plant_id = null
      } else if (this.company.length === 2) {
        this.listQuery.group_list_id = this.company[0]
        this.listQuery.company_id = this.company[1]
        this.listQuery.plant_id = null
      } else if (this.company.length === 3) {
        this.listQuery.group_list_id = this.company[0]
        this.listQuery.company_id = this.company[1]
        this.listQuery.plant_id = this.company[2]
      } else {
        this.listQuery.group_list_id = null
        this.listQuery.company_id = null
        this.listQuery.plant_id = null
      }
      this.LoadData()
    },
    selectOperationTime () {
      if (this.addtimeBTTime) {
        this.listQuery.addtimeBTTime = this.addtimeBTTime
      } else {
        this.listQuery.addtimeBTTime = []
      }
      this.LoadData()
    },
    LoadData () {
      this.qyloading = true // 页面区域loading
      this.isLoading = true
      if (this.current_user.id === 2 || this.current_user.id === 100 || this.current_user.id === 69) {
        // this.$delete(this.listQuery, 'user_id')
      } else {
        this.listQuery.user_id = this.current_user.id
      }
      this.api.Query(this.listQuery).then(response => {
        for (var i = 0; i < response.items.length; i++) {
          if (response.items[i].buy_detail_purchase.length === 0) {
            response.items[i].buy_detail_purchase = [
              {
                buy_detail_id: null,
                pay_state: '',
                pay_source: '',
                invoice: '',
                shop: '',
                pay_address: '',
                open_info: '',
                supplier_id: null,
                logistics_type: '快递',
                logistics: [],
                tracking_number: '',
                tel: '',
                deliveryMan: '',
                remark: '',
                upload_type: '回执单',
                voucher: [],
                addtime: new Date(),
                order: '1'
              }
            ]
          }
        }
        this.list = response.items
        this.total = response.total
        this.amount = response.amount
        this.isLoading = false
        this.qyloading = false
      })
      this.TableScrollTop()
    },
    dandian (column, event) {
      this.isFixed[column.index] = !this.isFixed[column.index]
    },
    operationManual () {
      this.$nextTick(() => {
        this.$refs.preview.clickHandler()
      })
    },
    changeinvoice (state) {
      api.changeinvoice(state).then((response) => {
        this.$notify({ title: '成功', message: response.message, type: 'success', duration: 2000 })
      })
    },
    removeUpload (obj, file, fileList) {
      this.form.buy_detail_purchase[obj.index].buy_detail_purchase.voucher = fileList
    },
    removeUpload_invoice (file, fileList) {
      this.myfileList_invoice = fileList
    },
    handlesuccess (obj, response, file, fileList) {
      if (response.code === 20000) {
        this.form.buy_detail_purchase[obj.index].buy_detail_purchase.voucher = fileList
      } else {
        this.$message.error(response.message)
      }
    },
    handlesuccess_invoice (response, file, fileList) {
      if (response.code === 20000) {
        this.myfileList_invoice = fileList
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const extension3 = testmsg === 'docx'
      const extension4 = testmsg === 'doc'
      const extension5 = testmsg === 'jpg'
      const extension6 = testmsg === 'pdf'
      const extension7 = testmsg === 'zip'
      const extension8 = testmsg === 'rar'
      const extension9 = testmsg === 'png'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6 && !extension7 && !extension8 && !extension9) {
        this.$message({
          message: '上传文件只能是 xls、xlsx、docx、doc、jpg、png、pdf、zip、rar格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      return (extension || extension2 || extension3 || extension4 || extension5 || extension6 || extension7 || extension8 || extension9) && isLt2M
    },
    getBusinessOrdersList (type) {
      busOrders.getScreenBusOrdersList({user_id: this.current_user.id, type: type}).then(response => {
        this.businessOrdersList = response.message
      })
    },
    // 查询信息回调
    handleChange (value) {
      if (value.length > 0) {
        busOrders.getBusOrdersQueryData({BusOrdersArr: value}).then(response => {
          if (response.code === 20000) {
            // 厂区
            this.form.companyList = response.data.companyList
            // 采购描述
            if (this.form.parets_name === '') {
              this.form.parets_name = response.data.material_des
            }
            // 单位
            this.form.units = response.data.units
            // 数量
            if (this.form.number === 0) {
              this.form.number = response.data.number
            }
            // 采购价
            // this.form.price = response.data.tax_price
            // 订单总价
            this.form.order_price = response.data.tax_price * response.data.number
            // 备注
            this.form.ordnumber_code = '采购订单号：' + response.data.purchase_order_num + '　物料编码：' + response.data.material_code
          }
        })
      } else {
        this.getBusinessOrdersList(this.form.business_orders_goods_id ? this.form.business_orders_goods_id : '1')
      }
    },
    dowloadFile (urlFile) {
      window.open(urlFile.message, '_blank')
    },
    getcateGoods () {
      api.getcateGoods().then(res => {
        this.cateList = res.data
      })
    },
    changedstatus (row, fieldName) {
      const params = { id: row.id }
      params[fieldName] = row[fieldName]
      api.changedstatus(params).then(res => {
        if (res.code === 20000) {
          this.$message({ message: '操作成功', type: 'success' })
        } else {
          this.$message({ message: '操作失败', type: 'error' })
        }
      })
    },
    // 批量导出
    Export () {
      if (this.$refs.singleTable.selection.length > 0) {
        var ids = this.$refs.singleTable.selection.map(a => a[this.primary_key])
        api.export({id: ids}).then(response => {
          if (response.code === 20000) {
            window.open(response.savename)
          } else {
            this.$message.error('导出错误')
          }
        })
      } else if (this.addtimeBTTime && this.addtimeBTTime.length > 0) {
        api.export({listQuery: this.listQuery}).then(response => {
          if (response.code === 20000) {
            window.open(response.savename)
          } else {
            this.$message.error('导出错误')
          }
        })
      } else {
        this.$message({ message: '请选择导出时间或要导出的数据', type: 'error' })
      }
    },
    getUserList () {
      busOrders.getUserList({MAccountRole: '1, 5'}).then(response => {
        this.optionsUserList = response.data
      })
    },
    close () {},
    checkLogistics (row) {
      this.activities = []
      this.isShow = true
      workdiary.checkLogistics({ com: row.buy_detail_purchase[0].expressagebh, nu: row.buy_detail_purchase[0].tracking_number, tel: row.tel }).then(res => {
        if (res.item.status === '0') {
          this.activities = res.item.result.list.reverse()
        } else {
          this.$message.error(res.item.msg)
        }
      })
    },
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          api.getSupplierList({ search: query }).then(res => {
            this.options = res.items.filter(item => {
              return item.company_name.toLowerCase().indexOf(query.toLowerCase()) > -1
            })
            this.loading = false
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    // 顶部滚动条
    handleScrollTop () {
      if (this.$refs.topScroll) {
        let scrollLeft = this.$refs.topScroll.scrollLeft
        this.$refs.singleTable.bodyWrapper.scrollTo(scrollLeft, 0)
      }
    },
    TableScrollTop () {
      setTimeout(() => {
        if (this.$refs.singleTable) {
          this.tableWidth.width = this.$refs.singleTable.bodyWrapper.scrollWidth + 'px'
          this.$refs.singleTable.doLayout()
          // 此代码为监听表格滚动条的事件：
          this.tableDom = this.$refs.singleTable.bodyWrapper
          this.tableDom.addEventListener('scroll', () => {
            // 滚动距离
            let scrollLeft = this.tableDom.scrollLeft
            this.$refs.topScroll.scrollTo(scrollLeft, 0)
          })
        }
      }, 500)
    },
    getUrl (str) {
      const reg = /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
      const strValue = str.match(reg)
      if (strValue && strValue.length > 0) {
        return strValue[0]
      }
      return null
    },
    customFilterMethod (node, keyword) {
      // 自定义搜索逻辑，这里简单示例为：直接替换搜索值
      if (node.label.includes(keyword.split('/').join('\\'))) {
        const newLabel = node.label.replace(keyword, `<strong>${keyword}</strong>`)
        return {
          ...node,
          label: newLabel
        }
      }
      return false
    },
    // 供应商信息
    geteditSupplierList (id, index) {
      api.getSupplierList({'id': id}).then(response => {
        this.options = response.items
        this.form.buy_detail_purchase[index].buy_detail_purchase.supplier_id = response.items[0]['id']
        this.form.buy_detail_purchase[index].SupplierList = response.items[0]
        this.form.buy_detail_purchase[index].buy_detail_purchase.pay_address = response.items[0]['company_url']
      })
    },
    // 获取供应商所有信息
    getAllSupplierList () {
      api.getAllSupplierList({'is_project': '0'}).then(response => {
        this.SupplierOptions = response.items
      })
    },
    // 获取支付方式
    handleChangePayState (value, indexss) {
      if (value.buy_detail_purchase.pay_state === '4') {
        this.form.buy_detail_purchase[indexss].buy_detail_purchase.pay_source = '11'
      } else {
        this.form.buy_detail_purchase[indexss].buy_detail_purchase.pay_source = ''
      }
    },
    addTab (targetName) {
      let newTabName = ++this.tabIndex + ''
      this.form.buy_detail_purchase.push({
        title: '采购信息' + newTabName,
        name: newTabName,
        SupplierList: [],
        buy_detail_purchase: {
          buy_detail_id: null,
          pay_state: '',
          pay_source: '',
          invoice: '',
          shop: '',
          pay_address: '',
          open_info: '',
          supplier_id: null,
          logistics_type: '快递',
          logistics: [],
          tracking_number: '',
          tel: '',
          deliveryMan: '',
          remark: '',
          upload_type: '回执单',
          voucher: [],
          addtime: new Date(),
          order: newTabName
        }
      })
      this.editableTabsValue = newTabName
    },
    removeTab (targetName) {
      let tabs = this.form.buy_detail_purchase
      let activeName = this.editableTabsValue
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
            }
          }
        })
      }
      this.editableTabsValue = activeName
      this.form.buy_detail_purchase = tabs.filter(tab => tab.name !== targetName)
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 40px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 85%;
}
.el-image >>> .el-image-viewer__close{
  color: #fff;
}
.top-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 15px;
}
.top-scroll-content {
  background-color: #fff;
  height: 1px;
}
.set-content{
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 文本溢出时显示省略号 */
  white-space: nowrap; /* 文本不换行 */
}
.borderStyle{
  margin-top: 3px;
  width: 100px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}
.borderStyleS{
  font-weight: bold;
  color: #409EFF;
  font-size: 17px;
  margin-top: 3px;
  width: 100px;
  height: 32px;
  text-align: left;
  line-height: 32px;
}
.border-box{
  width: 100%;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  margin-bottom: 10px;
}
.border-boxs{
  margin-bottom: -1px;
}
</style>
<style>
.el-dialog__body {
  padding: 0px 20px;
}
.my-custom-class{
  color: #409EFF;
}
.el-table__row td {
  padding: 0 0 0 0 !important;
  height:60px;
}
.el-tabs__header{
  margin-bottom: -1px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/member/expense_account.vue